import Modal from "../../../Modal.tsx";
import {ImageDisplay} from "./ImageDisplay.tsx";
import {getImageTypeDisplay} from "../../dyanimcFormUtil.tsx";
import React from "react";
import {ImageSubmission} from "../../../../api/ApiTypes.ts";

interface FullSizeImageModalProps { selectedModalImage: ImageSubmission | null, onClose: () => void }

export const FullSizeImageModal: React.FC<FullSizeImageModalProps> = ({selectedModalImage: selectedModalImage, onClose}) => {
    if (!selectedModalImage) return null;

    return (
        <Modal
            isOpen={!!selectedModalImage}
            onClose={onClose}
            title={selectedModalImage.fileName}
            maxWidth="full"
        >
            <div className="flex flex-col space-y-4 h-full">
                <div className="relative w-full flex-1 min-h-0 bg-gray-100 rounded">
                    <ImageDisplay image={selectedModalImage}/>
                </div>

                <div className="flex-shrink-0 space-y-2">
                    <div>
                        <span className="text-sm font-semibold text-gray-600">Type: </span>
                        <span className="text-sm">{getImageTypeDisplay(selectedModalImage.imageType) || 'None'}</span>
                    </div>

                    <div>
                        <span className="text-sm font-semibold text-gray-600">Comments: </span>
                        <p className="text-sm mt-1">{selectedModalImage.comments}</p>
                    </div>
                </div>
            </div>
        </Modal>
    )
}